import type { Brand } from '@seek/melways-sites';
import { metrics } from '@seek/metrics-js';

import ACCOUNT_EXISTS from '../modules/graphql/accountExists';
import getClient from '../modules/graphql/getClient';
import type { AccountExistsPayload } from '../modules/graphql/types';
import { type EmailLookupResult, type Environment, Experience } from '../types';

// Later, we may want to add this to customisations. Use experience for now.
const shouldUseRealmHint = (experience: Experience) =>
  experience === Experience.Hirer;

export const performEmailLookup = async (
  email: string,
  environment: Environment,
  experience: Experience,
  locale: string,
  brand: Brand = 'seek',
): Promise<EmailLookupResult> => {
  metrics.count('perform_email_lookup', [`experience:${experience}`]);

  const client = getClient(environment, { locale, brand });
  const { data } = await client.query<{ accountExists: AccountExistsPayload }>({
    query: ACCOUNT_EXISTS,
    variables: {
      email,
    },
  });
  const result: EmailLookupResult = {
    realmHint: data.accountExists.realmHint,
  };

  if (!shouldUseRealmHint(experience)) {
    delete result.realmHint;
  }

  return result;
};
